/**
 * @generated SignedSource<<1dac6b415f8c7c594d958f1f26b68c26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type UpdateRuleInputObject = {
  accountIds?: ReadonlyArray<string> | null | undefined;
  caseSensitive?: boolean | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  direction?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endDate?: any | null | undefined;
  expenseNatureId?: string | null | undefined;
  matchKind?: string | null | undefined;
  overrideTxnIds?: ReadonlyArray<string> | null | undefined;
  reattributeScope?: string | null | undefined;
  regex?: string | null | undefined;
  ruleId: string;
  stakeholderId?: string | null | undefined;
  stakeholderName?: string | null | undefined;
  startDate?: any | null | undefined;
  targetClassification?: TxnClassificationEnum | null | undefined;
};
export type ruleDetailPage_UpdateRuleMutation$variables = {
  input: UpdateRuleInputObject;
};
export type ruleDetailPage_UpdateRuleMutation$data = {
  readonly updateRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_UpdateRuleMutation = {
  response: ruleDetailPage_UpdateRuleMutation$data;
  variables: ruleDetailPage_UpdateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Stakeholder",
      "kind": "LinkedField",
      "name": "stakeholder",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1068ea13506b6bbdf0b103cba6edffa8",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_UpdateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_UpdateRuleMutation(\n  $input: UpdateRuleInputObject!\n) {\n  updateRule(input: $input) {\n    rule {\n      id\n      stakeholder {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6875f3e4b93f8f535a69a06f032558c3";

export default node;
